var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 18",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Zealand flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    fill: "#00247D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#CC142B",
    stroke: "#FFFFFF",
    strokeWidth: 0.6
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "16,4 16.4,5 17.5,5 16.6,5.6 17,6.7 16,6 15,6.7 15.4,5.6 14.5,5 15.6,5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.2,7 19.6,8 20.7,8 19.8,8.6 20.2,9.7 19.2,9 18.2,9.7 18.6,8.6 17.7,8 18.8,8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15,10.2 15.4,11.2 16.5,11.2 15.6,11.8 16,12.9 15,12.2 14,12.9 14.4,11.8 13.5,11.2 14.6,11.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18,12.8 18.4,13.8 19.5,13.8 18.6,14.4 19,15.5 18,14.8 17,15.5 17.4,14.4 16.5,13.8 17.6,13.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNz);
export default __webpack_public_path__ + "static/media/nz.33fbe98024cfc71ded7a7b77d5ceb9d7.svg";
export { ForwardRef as ReactComponent };